import { ConfluenceIcon } from "#components/ui/ConfluenceIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const confluenceManifest: IntegrationManifest = {
    key: "confluence",
    displayName: "Confluence",
    nameKey: "channels.confluence",
    descriptionKey: "confluencePersonalDescription",
    trayDescriptionKey: "composerTrayDescriptions.confluence",
    cardDescriptionKey: "connectIntegration.descriptions.confluence",
    connectedContentKeys: ["confluencePersonalPages"],
    brandColor: "#1868DB",
    iconUrl: IconAssets.Confluence,
    iconUrlAlt: IconAssets.ConfluenceAlt,
    glyph: ConfluenceIcon,
    channelType: "UserConfluence",
    dataSources: ["confluence_page"]
};
